import { SIX_TOPIC } from '@/config/networkConstants';
import type { MessagePayload } from '@/types/poc/message';
import { MAX_RESEND_ATTEMPTS } from '@/store/listeners/poc/pendingAckCoordinator';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { FileMetadata } from '@/types/poc/helia';
interface AnnounceFileReadyArgs {
  sixId: string;
  cid: string;
  metadata: FileMetadata;
  targetPeerId?: string;
  uploadId: string;
  attemptCount?: number;
}

interface AnnounceFileReadyResult {
  sixId: string;
  cid: string;
  messageId: string;
  sent: boolean;
  usedProtocol: boolean;
  attemptCount: number;
}

export const sendFileAnnouncement = createAppAsyncThunk<
  AnnounceFileReadyResult,
  AnnounceFileReadyArgs
>(
  'messaging/sendFileAnnouncement',
  async(
    {
      sixId,
      cid,
      uploadId,
      metadata,
      targetPeerId,
      attemptCount = 1,
    },
    { dispatch, extra: { pocServices, loggerService }, rejectWithValue }
  ) => {
    try {
      const log = loggerService.createLogger({ namespace: 'six3ro:p2p:messaging' });
      const { p2pStackManagerService, messagingService } = pocServices;
      const libp2pNode = p2pStackManagerService.getLibp2pNode(sixId);

      if (libp2pNode == null) {
        throw new Error(`LibP2P node not available for six '${sixId}'`);
      }

      const message: MessagePayload = {
        type: 'file-ready-for-download',
        id: crypto.randomUUID(),
        cid,
        metadata,
        targetPeerId,
        sender: libp2pNode.peerId.toString(),
        timestamp: Date.now(),
      };

      await messagingService.publishMessage(libp2pNode, SIX_TOPIC(sixId), message);

      log.info(
        `[${sixId}] File ready for download message ${message.id} sent (attempt ${attemptCount}/${MAX_RESEND_ATTEMPTS}) for file: ${metadata.name}`
      );

      return { sixId, cid, messageId: message.id, sent: true, usedProtocol: false, attemptCount };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return rejectWithValue({ message });
    }
  }
);
